<template>
	<figure>
		<slot name="blockquote">
			<blockquote :cite="data.cite">
				<p v-interpolation
				   class="up-text"
				   v-html="data.quote" />
			</blockquote>
		</slot>

		<slot name="figcaption">
			<figcaption v-if="data.person">
				<i class="icon">
					<iconCircle />
				</i>
				<div class="quote-source">
					<span v-if="data.person"
						  class="quote-person">{{ data.person }}&nbsp;</span>
					<span v-if="data.organisation"
						  class="quote-org">{{ data.organisation }}</span>
				</div>
			</figcaption>
		</slot>
	</figure>
</template>

<script setup>
import iconCircle from '~/assets/images/icon-circle.svg'

defineProps({
	data: {
		type: Object,
		required: true,
	},
})
</script>
